import React, {useState, useEffect} from "react";
import Layout from "./Layout";
import ContentLoader from "../../utils/ContentLoader";
import Paginate from "../../utils/Pagination";
import ReactSelect from 'react-select';
//import "./../../Public/css/leads_list.css";
import { Modal, Button, Offcanvas } from 'react-bootstrap';
import { Link } from "react-router-dom";
import moment from "moment";
import {CollegeCallerDataAPI, AddCollegeMappingAPI, CallerDataLoadAPI} from "./../../API/Sales/CollegeMappingAPI";

const CollegeCallermapping = () =>{

    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);
    const [collegeid, setCollegeId] = useState("");
    const [teamid, setTeamId] = useState("");
    const [selectedteam, setSelectedTeam] = useState({});
    const [selectedcollege, setSelectedCollege] = useState({});
    const [selectedcallerids, setSelectedCallerIds] = useState([]);
    const [isleadaddmodal, setIsLeadAddModal] = useState(false);
    const [btnsubmitloader, setBtnSubmitLoader] = useState(false);
    const [isreloadrecords, setIsReloadRecords] = useState(false);
    const [formerror, setFormError] = useState({});
    const [collegelist, setCollegeList] = useState([]);
    const [callerslist, setCallersList] = useState([]);
    const [selectedcaller, setSelectedCaller] = useState([]);
    const [selectedcallervalues, setSelectedCallerValues] = useState([]);
    const [teamlist, setTeamList] = useState([]);

    const perpagedata = 20;

    useEffect(() => {
    
            CollegeCallerDataAPI(setRecords, setLoading, currentPage, perpagedata, setPageCount, setCollegeList, setTeamList);
    
    }, [currentPage, isreloadrecords]);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

    }

    const handleLeadAddModal = () =>{
		setIsLeadAddModal(!isleadaddmodal);
	}

	const handleLeadAddModalHide = () =>{
        setIsLeadAddModal(false);
    }

    const handleCollegeData = (selcollege) =>{
        console.log('selected college====' + selcollege);

        if(selcollege)
        {
            let collegevalue = selcollege.value;

            //setTxtCollege(collegevalue);
            setCollegeId(collegevalue);
            setSelectedCollege(selcollege);

        }


    }

    const handleTeams = (selteam) =>{
        console.log('selected team=====' + selteam);

        if(selteam)
        {
            let teamvalue = selteam.value;

            //setTxtTeam(teamvalue);

            setTeamId(teamvalue);

            setSelectedTeam(selteam);

            CallerDataLoadAPI(teamvalue, setCallersList);

        }
    }

    const handleCallers = (selcallers) =>{

        console.log('selected callers===' + JSON.stringify(selcallers));

        if(selcallers)
        {
            let callervalue = selcallers.map(datalist => datalist.value);

            setSelectedCallerValues(callervalue);

            setSelectedCallerIds(callervalue);

            setSelectedCaller(selcallers);
        }

        //setSelectedCallerIds(e.target.value);
    }

    const resetCollegeForm = () =>{
    
        //setTxtCollege("");
        setCollegeId("");

        setSelectedCallerIds([]);
    }

    const validateForm = () => {
        let errors = {};

        console.log("college id====" + collegeid);
        console.log("selectedcallerids id====" + selectedcallerids);

        if (!collegeid) {
            errors.errortxtcollege = true;
        }

        if (!selectedcallerids || selectedcallerids.length === 0) {
            errors.errorcaller = true;
        }

        return errors;
    };

    const handleAddCollegeMapping = (e) =>{

        e.preventDefault();

        const errors = validateForm();

        setFormError(errors);

        const hasError = Object.keys(errors).length > 0;

        if (hasError)
        {
            console.log("Form error");
            return;
        }
        else
        {
            console.log("Form success");

            console.log('College id====' + collegeid);
            console.log('Team id====' + teamid);
            console.log('Caller id====' + selectedcallerids);

            let formdata = new FormData();
            formdata.append('collegeid', collegeid);
            formdata.append('teamid', teamid);
            //formdata.append('callerids', selectedcallerids);
            selectedcallerids.forEach(id => {
                formdata.append('callerids[]', id);
            });



            console.log('form data=========' + formdata);
            console.log('form data=========' + JSON.stringify(formdata));
            //setBtnSubmitLoader(true);
            AddCollegeMappingAPI(formdata, setBtnSubmitLoader, setIsLeadAddModal, resetCollegeForm, setIsReloadRecords);
        }
    }


    return(
    <Layout>
        <div className="content">

            <div className="row">
                <div className="col-md-12">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-8">
                                <h4 className="page-title">College Mapping</h4>
                            </div>
                            <div className="col-4 text-end">

                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-12">

                    <div className="row crm-filter-row-top align-items-center">

                        <div className="mb-1 d-flex  justify-content-end align-items-center">
                            <button className="btn btn-success me-2" onClick={handleLeadAddModal}>
                                <i className="ti ti-plus me-2"></i> Add College Mapping
                            </button>                            
                        </div>
                    </div>

                    <Offcanvas show={isleadaddmodal} onHide={handleLeadAddModalHide} placement="end" className="offcanvas-custom">
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title id="contained-modal-title-vcenter">Add College Mapping</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <div class="row crm-filter-row-bottom align-items-end">
                                <div className="col-md-12 mb-1">
                                    <label class="crm-filter-label">College</label>
                                    <ReactSelect className="" value={selectedcollege} onChange={handleCollegeData} options={collegelist} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select College"></ReactSelect>
                                </div>

                                <div className="col-md-12 mb-1">
                                    <label class="crm-filter-label">Teams</label>
                                    <ReactSelect className="" value={selectedteam} onChange={handleTeams} options={teamlist} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Team"></ReactSelect>
                                </div>                                

                                <div className="col-md-12 mb-1">
                                    <label class="crm-filter-label">Caller</label>
                                    <ReactSelect className="" value={selectedcaller} onChange={handleCallers} options={callerslist} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Caller" isMulti></ReactSelect>
                                </div>
                            </div>

                            <div class="crm-filter-actions">
                                <button type="button" class="btn btn-cancel" data-bs-dismiss="modal" onClick={handleLeadAddModalHide}>Close</button>

                                <button type="button" className="btn btn-primary me-2" onClick={handleAddCollegeMapping}>
                                    {btnsubmitloader ?
                                        <div className="spinner-border" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    :
                                        <>Add College Mapping</>
                                    }
                                </button>

                            </div>
                        </Offcanvas.Body>

                    </Offcanvas>
                </div>



                <div className="col-md-12">
                    <div className="card">

                        <div className="card-body">
                            

                            <div className="table-responsive table-wrapper">
                                {loading ?

                                    <ContentLoader />
                                :
                                <table className="table table-data-section" id="">
                                    <thead className="thead-light">
                                        <tr>
                                            
                                            <th className="sortable-column"> Colleges </th>
                                            <th className="sortable-column"> Caller </th>
                                            <th className="sortable-column"> Team </th>
                                            <th className="sortable-column"> Created Date </th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                    {records && records.length > 0  ?
                                        records.map(lead =>
                                        (

                                            <tr key={lead.id}>
                                                <td>
                                                    <Link to={`/caller/lead-profile/${lead.id}`} className="">
                                                    {lead.collegename}
                                                    </Link>
                                                </td>
                                                <td>{lead.callername}</td>
                                                <td>{lead.teamname}</td>
                                                <td> {moment(lead.created_at).format('DD-MM-YYYY h:mm')} </td>
                                            </tr>
                                        ))

                                    :

                                        <tr>
                                            <td colSpan="4">
                                                <p>No record found...</p>
                                            </td>
                                        </tr>
                                    }

                                    </tbody>
                                </table>
                                }
                            </div>
                        </div>
                    </div>

                    {pagecount > 1 ?
                    <div className="pagination-section mt-3">

                        <nav>
                            <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                        </nav>
                    </div>
                    :
                        <></>
                    }

                </div>
            </div>

        </div>
    </Layout>
    )
}

export default CollegeCallermapping;
